import { ColDef } from 'ag-grid-community';
import { AgTableWithBaseStyle } from '../../../components/AgTable/AgTable2';
import { TransactionHistoryTableData } from '../../../types';

type Props = {
  data: TransactionHistoryTableData[];
  columnDefs: ColDef<TransactionHistoryTableData>[];
};

const defaultColDef: ColDef = {
  width: 180,
  minWidth: 150,
  maxWidth: 400,
  resizable: true,
  sortable: false,
  filter: false,
};

export const TransactionHistoryTable = ({ data, columnDefs }: Props) => {
  return (
    <div style={{ width: '100%', marginBottom: '2rem' }}>
      <AgTableWithBaseStyle
        rowData={data}
        columnDefs={columnDefs}
        domLayout='autoHeight'
        defaultColDef={defaultColDef}
        suppressMovableColumns
      />
    </div>
  );
};
